//@ts-ignore
//libraries

import "../css/Website.scss";
import Navigation from "../components/navigation/Navigation";
import OutroCTA from "../components/OutroCTA";
import Footer from "../components/Footer";

const Terms = () => {
  return (
    <div id="stippl-about">
      <Navigation impact={false} />
      <div style={{ paddingTop: "5rem", paddingBottom: "4rem" }}>
      <div className="container__full-width">
        <div className="container__inner">
          <div className="legal-container">
            <h1>Terms and Conditions</h1>
            <p>
              <em>Stippl B.V., stippl.io · Last updated: October 2026 · Replaces version of May 2026</em>
            </p>
            <p>Please read these terms and conditions carefully before using Our Service.</p>

            <h2 id="interpretation-definitions">1. Interpretation and Definitions</h2>
            <h3 id="interpretation">1.1 Interpretation</h3>
            <p>
              The words of which the initial letter is capitalised have meanings defined under the following conditions.
              The following definitions shall have the same meaning regardless of whether they appear in singular or in
              plural.
            </p>
            <h3 id="definitions">1.2 Definitions</h3>
            <p>For the purposes of these Terms and Conditions:</p>
            <ul>
              <li>
                <strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control
                with a party, where "control" means ownership of 50% or more of the shares, equity interest or other
                securities entitled to vote for election of directors or other managing authority.
              </li>
              <li>
                <strong>Account</strong> means a unique account created for You to access our Service or parts of our
                Service.
              </li>
              <li>
                <strong>AI Features</strong> means any artificial intelligence-powered tools, suggestions, or content
                generation features provided as part of the Service.
              </li>
              <li>
                <strong>Country</strong> refers to: Netherlands.
              </li>
              <li>
                <strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement)
                refers to Stippl B.V., Ruimzicht 129, 1068CS Amsterdam, the Netherlands, registered in the Dutch Chamber
                of Commerce (KvK) under number 82938865.
              </li>
              <li>
                <strong>Content</strong> refers to content such as text, images, or other information that can be
                posted, uploaded, linked to or otherwise made available by You, regardless of the form of that content.
              </li>
              <li>
                <strong>Device</strong> means any device that can access the Service such as a computer, a cellphone, or
                a digital tablet.
              </li>
              <li>
                <strong>Feedback</strong> means feedback, innovations or suggestions sent by You regarding the
                attributes, performance or features of our Service.
              </li>
              <li>
                <strong>Nuitee</strong> means Nuitee Travel Limited, Stippl's exclusive accommodation supply partner for
                Stays bookings.
              </li>
              <li>
                <strong>Service</strong> refers to the Stippl application and web application (together: the App),
                accessible at{" "}
                <a href="https://www.stippl.io/" target="_blank" rel="noopener noreferrer">
                  https://www.stippl.io/
                </a>
                .
              </li>
              <li>
                <strong>Stays</strong> means the accommodation search and booking feature within the Service, powered
                exclusively by Nuitee.
              </li>
              <li>
                <strong>Terms and Conditions</strong> (also referred to as "Terms") mean these Terms and Conditions that
                form the entire agreement between You and the Company regarding the use of the Service.
              </li>
              <li>
                <strong>Third-party Login Service</strong> means a third-party authentication service (such as Google or
                Apple) that You may use to sign in to the Service.
              </li>
              <li>
                <strong>Website</strong> refers to Stippl, accessible from{" "}
                <a href="https://www.stippl.io/" target="_blank" rel="noopener noreferrer">
                  https://www.stippl.io/
                </a>
                .
              </li>
              <li>
                <strong>You</strong> means the individual accessing or using the Service, or the company, or other legal
                entity on behalf of which such individual is accessing or using the Service, as applicable.
              </li>
            </ul>

            <h2 id="acknowledgment">2. Acknowledgment</h2>
            <p>
              These are the Terms and Conditions governing the use of this Service and the agreement that operates
              between You and the Company. These Terms and Conditions set out the rights and obligations of all users
              regarding the use of the Service.
            </p>
            <p>
              Your access to and use of the Service is conditioned on Your acceptance of and compliance with these Terms
              and Conditions. These Terms and Conditions apply to all visitors, users, and others who access or use the
              Service.
            </p>
            <p>
              By accessing or using the Service You agree to be bound by these Terms and Conditions. If You disagree
              with any part of these Terms and Conditions then You may not access the Service.
            </p>
            <p>You represent that you are over the age of 18. The Company does not permit those under 18 to use the Service.</p>
            <p>
              Your access to and use of the Service is also conditioned on Your acceptance of and compliance with the{" "}
              <a href="/privacy">Privacy Policy</a> of the Company. Our Privacy Policy describes Our policies and
              procedures on the collection, use, and disclosure of Your personal information when You use the
              Application or the Website and tells You about Your privacy rights and how the law protects You. Please
              read Our Privacy Policy carefully before using Our Service.
            </p>

            <h2 id="user-accounts">3. User Accounts</h2>
            <p>
              3.1. When You create an account with Us, You must provide Us information that is accurate, complete, and
              current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate
              termination of Your account on Our Service.
            </p>
            <p>
              3.2. You are responsible for safeguarding the password that You use to access the Service and for any
              activities or actions under Your password, whether Your password is with Our Service or a Third-Party
              Login Service.
            </p>
            <p>
              3.3. You agree not to disclose Your password to any third party. You must notify Us immediately upon
              becoming aware of any breach of security or unauthorized use of Your account.
            </p>
            <p>
              3.4. You may not use as a username the name of another person or entity or that is not lawfully available
              for use, a name or trademark that is subject to any rights of another person or entity other than You
              without appropriate authorization, or a name that is otherwise offensive, vulgar or obscene.
            </p>

            <h2 id="content">4. Content</h2>
            <h3 id="posting-content">4.1 Your Right to Post Content</h3>
            <p>
              Our Service allows You to post Content. You are responsible for the Content that You post to the Service,
              including its legality, reliability, and appropriateness.
            </p>
            <p>
              By posting Content to the Service, You grant Us the right and license to use, modify, publicly perform,
              publicly display, reproduce, and distribute such Content on and through the Service. You retain any and
              all of Your rights to any Content You submit, post or display on or through the Service and You are
              responsible for protecting those rights. You agree that this license includes the right for Us to make
              Your Content available to other users of the Service, who may also use Your Content subject to these
              Terms.
            </p>
            <p>
              You represent and warrant that: (i) the Content is Yours (You own it) or You have the right to use it and
              grant Us the rights and license as provided in these Terms, and (ii) the posting of Your Content on or
              through the Service does not violate the privacy rights, publicity rights, copyrights, contract rights or
              any other rights of any person.
            </p>
            <h3 id="content-restrictions">4.2 Content Restrictions</h3>
            <p>
              The Company is not responsible for the content of the Service's users. You expressly understand and agree
              that You are solely responsible for the Content and for all activity that occurs under your account,
              whether done so by You or any third person using Your account.
            </p>
            <p>
              You may not transmit any Content that is unlawful, offensive, upsetting, intended to disgust, threatening,
              libelous, defamatory, obscene or otherwise objectionable. Examples of such objectionable Content include,
              but are not limited to, the following:
            </p>
            <ul>
              <li>Unlawful or promoting unlawful activity.</li>
              <li>
                Defamatory, discriminatory, or mean-spirited content, including references or commentary about religion,
                race, sexual orientation, gender, national/ethnic origin, or other targeted groups.
              </li>
              <li>
                Spam, machine- or randomly-generated content, constituting unauthorized or unsolicited advertising,
                chain letters, any other form of unauthorized solicitation, or any form of lottery or gambling.
              </li>
              <li>
                Containing or installing any viruses, worms, malware, trojan horses, or other content that is designed
                or intended to disrupt, damage, or limit the functioning of any software, hardware or telecommunications
                equipment or to damage or obtain unauthorized access to any data or other information of a third person.
              </li>
              <li>
                Infringing on any proprietary rights of any party, including patent, trademark, trade secret, copyright,
                right of publicity or other rights.
              </li>
              <li>Impersonating any person or entity including the Company and its employees or representatives.</li>
              <li>Violating the privacy of any third person.</li>
              <li>False information and features.</li>
            </ul>
            <p>
              The Company reserves the right, but not the obligation, to, in its sole discretion, determine whether or
              not any Content is appropriate and complies with these Terms, refuse or remove this Content. The Company
              further reserves the right to make formatting and edits and change the manner of any Content. The Company
              can also limit or revoke the use of the Service if You post such objectionable Content. As the Company
              cannot control all content posted by users and/or third parties on the Service, you agree to use the
              Service at your own risk. You understand that by using the Service You may be exposed to content that You
              may find offensive, indecent, incorrect or objectionable, and You agree that under no circumstances will
              the Company be liable in any way for any content, including any errors or omissions in any content, or any
              loss or damage of any kind incurred as a result of your use of any content.
            </p>
            <p>
              <strong>Content Moderation (Notice and Appeals):</strong> Where we restrict, remove, or suspend access to
              your Content or Account, we will inform you of our decision and the reasons for it, except where doing so
              would compromise security or legal obligations. If you believe a moderation decision is incorrect, you may
              contact us at <a href="mailto:support@stippl.io">support@stippl.io</a> within 6 months of the decision to request a review. We will assess your
              appeal and respond within a reasonable timeframe. This appeals mechanism is provided in accordance with
              the EU Digital Services Act (Regulation (EU) 2022/2065).
            </p>
            <h3 id="content-backups">4.3 Content Backups</h3>
            <p>
              Although regular backups of Content are performed, the Company does not guarantee there will be no loss or
              corruption of data.
            </p>
            <p>
              Corrupt or invalid backup points may be caused by, without limitation, Content that is corrupted prior to
              being backed up or that changes during the time a backup is performed.
            </p>
            <p>
              The Company will provide support and attempt to troubleshoot any known or discovered issues that may
              affect the backups of Content. But You acknowledge that the Company has no liability related to the
              integrity of Content or the failure to successfully restore Content to a usable state.
            </p>
            <p>
              You agree to maintain a complete and accurate copy of any Content in a location independent of the
              Service.
            </p>

            <h2 id="copyright">5. Copyright Policy</h2>
            <h3 id="ip-infringement">5.1 Intellectual Property Infringement</h3>
            <p>
              We respect the intellectual property rights of others. It is Our policy to respond to any claim that
              Content posted on the Service infringes a copyright or other intellectual property infringement of any
              person.
            </p>
            <p>
              If You are a copyright owner, or authorized on behalf of one, and You believe that the copyrighted work
              has been copied in a way that constitutes copyright infringement that is taking place through the Service,
              You must submit Your notice in writing to the attention of our copyright agent via email at{" "}
              <a href="mailto:support@stippl.io">support@stippl.io</a> and include in Your notice a detailed description of the alleged infringement.
            </p>
            <p>
              You may be held accountable for damages (including costs and legal fees) for misrepresenting that any
              Content is infringing Your copyright.
            </p>
            <h3 id="notice-takedown">5.2 Notice and Takedown: Copyright Infringement</h3>
            <p>
              If you believe that Content on the Service infringes your copyright or other intellectual property rights,
              you may submit a notice to us by email at <a href="mailto:support@stippl.io">support@stippl.io</a> with the subject line "Copyright Notice". Your
              notice should include:
            </p>
            <ul>
              <li>Identification of the copyrighted work or other intellectual property you claim is being infringed.</li>
              <li>
                Identification of the specific URL or location within the Service where the allegedly infringing
                material can be found.
              </li>
              <li>Your full name, postal address, telephone number, and email address.</li>
              <li>
                A statement that you have a good faith belief that the use of the material is not authorised by the
                rights holder, its agent, or the law.
              </li>
              <li>
                A statement, made in good faith, that the information in your notice is accurate and that you are the
                rights holder or are authorised to act on their behalf.
              </li>
            </ul>
            <p>
              Upon receipt of a valid notice, we will assess it and take appropriate action, which may include removal
              or disabling of access to the relevant Content. Knowingly submitting a false or misleading notice may give
              rise to liability under applicable law.
            </p>
            <p>
              This procedure applies under the EU Digital Services Act (Regulation (EU) 2022/2065) and Dutch copyright
              law (Auteurswet). We are not subject to the United States Digital Millennium Copyright Act (DMCA), which
              does not apply to our services.
            </p>

            <h2 id="subscriptions">6. Subscription Terms</h2>
            <h3 id="subscription-fees">6.1 Subscription Fees and Payment</h3>
            <p>
              Users can purchase a Pro subscription through our Service, which may be offered via various tiers with
              differing benefits and prices. Payment for subscriptions made through our mobile apps will be charged to
              your payment method on file with the iOS App Store or Google Play Store (depending on your platform) at
              confirmation of purchase. Web-based subscriptions are billed directly through Stripe, our payment
              processor for web payments.
            </p>
            <p>
              Subscription fees are charged in advance on a recurring basis and will vary according to the subscription
              plan selected by the user. We will provide you with the total subscription fee prior to charging you. All
              subscription fees are non-refundable, except as expressly provided in these Terms.
            </p>
            <h3 id="renewal-cancellation">6.2 Renewal and Cancellation</h3>
            <p>
              Subscriptions automatically renew unless auto-renew is turned off at least 24 hours before the end of the
              current period (for App Store and Google Play subscriptions). Your account will be charged for renewal
              within 24 hours prior to the end of the current period at the subscription fee associated with your
              subscription level.
            </p>
            <p>
              You can manage and cancel your subscriptions by going to your account settings on the iOS App Store or
              Google Play Store after purchase, or through your Stippl account settings for web-based subscriptions.
            </p>
            <h3 id="free-trials">6.3 Free Trials</h3>
            <p>
              From time to time, we may offer free trials for our Pro subscription. If you subscribe to a Pro
              subscription through a free trial, the free trial period will last for the period specified at the time of
              sign-up. Unless you cancel at least 24 hours before the end of the trial period (for App Store/Google
              Play) or before the end of the trial period (for web subscriptions), the subscription will automatically
              convert into a paid subscription, and your payment method will be charged the applicable subscription fee.
            </p>
            <h3 id="platform-terms">6.4 Platform-Specific Terms</h3>
            <p>
              When purchasing a subscription through the iOS App Store or Google Play Store, you acknowledge and agree
              to the terms and conditions of the respective platform, which may have its own set of policies regarding
              subscriptions, payments, and cancellations that apply in addition to these Terms.
            </p>
            <p>
              Please note that billing and transactions for App Store and Google Play purchases are handled by Apple and
              Google respectively. Any billing inquiries for app store purchases should be directed to the respective
              platform's support services.
            </p>
            <h3 id="price-changes">6.5 Price Changes</h3>
            <p>
              The Company reserves the right to change the subscription fees at any time. Any price changes will take
              effect following at least 30 days' email notice to you or through notification in the Service itself.
              Continued use of a paid subscription after a price change comes into effect constitutes your agreement to
              pay the modified subscription fee. Price changes will apply on a going-forward basis and will only take
              effect upon renewal of your subscription.
            </p>
            <h3 id="refunds">6.6 Refund Policy</h3>
            <p>
              All payments made to the Company for the Pro subscription are non-refundable, and there are no refunds or
              credits for partially used periods, except as required by applicable law. Following the cancellation of
              your Pro subscription, you will continue to have access to the subscription until the end of your current
              billing period.
            </p>
            <h3 id="right-of-withdrawal">6.7 Right of Withdrawal (EU Consumers)</h3>
            <p>
              If you are a consumer resident in the European Union, you have the right to withdraw from a subscription
              contract within 14 days of purchase without giving any reason, in accordance with the EU Consumer Rights
              Directive (2011/83/EU) and Dutch law (Article 6:230o Burgerlijk Wetboek).
            </p>
            <p>
              <strong>Waiver of withdrawal right:</strong> If you purchase a Pro subscription and request that
              performance begins immediately (i.e., you start using the Pro features before the 14-day withdrawal period
              has expired), you expressly acknowledge and agree that you waive your right of withdrawal once the service
              has been fully performed or, where performance is continuous, that you lose your right of withdrawal once
              performance has begun. You will be asked to confirm this waiver at the point of purchase.
            </p>
            <p>
              To exercise your right of withdrawal before performance has begun, contact us at <a href="mailto:support@stippl.io">support@stippl.io</a> with the
              subject line "Withdrawal: Subscription". We will issue a full refund within 14 days of receiving your
              withdrawal notice, using the same payment method you used for the original transaction.
            </p>
            <p>
              This section does not apply to subscriptions purchased through the Apple App Store or Google Play Store;
              those are governed by the respective platform's own cancellation and refund policies.
            </p>

            <h2 id="esim">7. eSIM Services</h2>
            <p>
              Stippl provides prepaid eSIM data service plans through its iOS mobile application, leveraging eSIM
              technology for flexible and convenient mobile data access across various global destinations. Our eSIM
              services are procured in partnership with Airalo, facilitating seamless connectivity for our customers.
            </p>
            <h3 id="esim-registration">7.1 Registration and Account Management</h3>
            <p>
              <strong>7.1.1 Registration:</strong> Customers wishing to use Stippl's eSIM services must register via the
              Stippl iOS app. The registration process requires providing your first and last name and a verifiable
              email address. Optionally, customers may enhance their service experience by uploading a profile photo and
              indicating travel preferences.
            </p>
            <p>
              <strong>7.1.2 Terms Acceptance:</strong> Registration is contingent upon agreeing to Stippl's General
              Terms and Conditions and <a href="/privacy">Privacy Policy</a>. These documents govern the use of our eSIM services and ensure
              informed consent from our customers.
            </p>
            <h3 id="esim-purchase">7.2 Purchase, Activation, and Usage</h3>
            <p>
              <strong>7.2.1 Selecting Service Plans:</strong> A variety of prepaid eSIM data plans are available, with
              plan availability subject to change based on country. Customers are encouraged to review their options
              within the app to find the best fit for their connectivity needs.
            </p>
            <p>
              <strong>7.2.2 Device Requirements:</strong> Before purchasing, customers must confirm that their device is
              compatible with eSIM technology and is unlocked. This confirmation is critical to ensure a smooth service
              experience.
            </p>
            <p>
              <strong>7.2.3 eSIM Download and Activation:</strong> Post-purchase, the responsibility for downloading and
              activating the eSIM falls to the customer. Stippl provides comprehensive instructions within the app and
              via email to facilitate this process, requiring a stable internet connection for success.
            </p>
            <h3 id="esim-duration">7.3 Service Duration, Suspension, and Termination</h3>
            <p>
              <strong>7.3.1 Service Commencement and Term:</strong> The service begins once the eSIM is successfully
              downloaded and activated, continuing until the plan's data allowance is depleted or the plan period
              expires.
            </p>
            <p>
              <strong>7.3.2 Rights to Suspend or Terminate:</strong> Stippl may suspend or terminate service in
              instances of terms violation, misuse, or fraudulent behaviour, with or without notice to the customer.
            </p>
            <h3 id="esim-responsibilities">7.4 Customer Responsibilities</h3>
            <p>
              <strong>7.4.1 Lawful Use:</strong> Customers are expected to use the eSIM services in full compliance with
              these Terms, along with all applicable laws and regulations.
            </p>
            <p>
              <strong>7.4.2 Account Security:</strong> Keeping account information secure and confidential is the
              customer's responsibility. Stippl cannot be held liable for losses or damages stemming from unauthorized
              account usage.
            </p>
            <h3 id="esim-payment">7.5 Payment, Taxes, and Refunds</h3>
            <p>
              <strong>7.5.1 Payment Processing:</strong> eSIM services are prepaid, with transactions securely handled
              through Stripe. The total price, inclusive of any applicable taxes based on billing details, will be
              clearly communicated at the time of purchase.
            </p>
            <p>
              <strong>7.5.2 Refund Considerations:</strong> Requests for refunds or plan exchanges are evaluated on a
              case-by-case basis, especially in scenarios where technical issues impede service utilisation. Affected
              customers should contact Stippl support at <a href="mailto:support+esim@stippl.io">support+esim@stippl.io</a> for assistance.
            </p>
            <h3 id="esim-general">7.6 General Provisions</h3>
            <p>
              Stippl endeavours to offer reliable eSIM services on an "as is" and "as available" basis. However, due to
              our reliance on technology and network capabilities provided by Airalo, we cannot guarantee uninterrupted
              service or network coverage. By using our eSIM services, customers agree to adhere not only to Stippl's
              terms but also to those set forth by Airalo, enhancing the framework for our service delivery.
            </p>
            <p>
              For support or inquiries related to our eSIM services, customers are encouraged to reach out through the
              app's contact features or by emailing <a href="mailto:support+esim@stippl.io">support+esim@stippl.io</a>.
            </p>

            <h2 id="stays">8. Stippl Stays</h2>
            <p>
              Stippl Stays allows You to search for and book accommodation directly within the Stippl app, powered
              exclusively by our partner Nuitee Travel Limited.
            </p>
            <p>
              Stays bookings are governed by the <a href="/stays-terms">Stippl Stays Booking Terms</a>, which form part
              of the agreement between You and Stippl and which You will be asked to accept when making your first
              booking. Please read them carefully before booking.
            </p>
            <p>
              By using Stippl Stays, you also agree to Nuitee's Terms and Conditions and the individual property's
              booking and cancellation policy, both of which are shown to you in the app before you confirm a booking.
            </p>
            <h3 id="not-package-travel">8.1 Stippl is Not a Package Travel Organiser</h3>
            <p>
              Stippl is not a package travel organiser ("reisorganisator") within the meaning of EU Directive 2015/2302
              on Package Travel and Linked Travel Arrangements, as implemented in Dutch law (Boek 7, Afdeling 7A,
              Burgerlijk Wetboek).
            </p>
            <p>
              Stippl Stays offers a single travel service: accommodation booked via Nuitee. A single travel service
              does not constitute a package under the Directive. Stippl's itinerary planning, route-building, and travel
              inspiration features are software and information tools only; they are not travel services within the
              meaning of the Directive. Stippl does not combine accommodation with transport, car rental, or other
              tourist services into a bookable package, and is therefore not subject to the insolvency protection and
              guarantee fund requirements (such as SGR membership) applicable to package travel organisers under Dutch
              law.
            </p>
            <p>
              If You combine a Stays booking with independently arranged services (flights, transport, activities), You
              do so at your own initiative. Stippl is not party to those arrangements and does not become a package
              travel organiser as a result.
            </p>
            <p>
              You acknowledge that (a) You are purchasing a single accommodation service, not a package; (b) any
              combination of that accommodation with other travel services You arrange independently does not create a
              package travel agreement with Stippl; (c) You are not entitled to the specific protections afforded to
              package travellers under Directive 2015/2302 in respect of your Stays booking; and (d) your statutory
              consumer rights under Dutch and EU law remain unaffected by this clause.
            </p>

            <h2 id="ai-features">9. AI Features</h2>
            <p>
              The Service includes AI-powered features such as destination suggestions, route recommendations, itinerary
              generation, and smart content tools ("AI Features"). Please note:
            </p>
            <ul>
              <li>AI Features are designed to assist, not replace, your own research and judgment.</li>
              <li>
                AI-generated content may be inaccurate, incomplete, or not suited to your specific circumstances. You
                are solely responsible for verifying any AI-generated content before acting on it.
              </li>
              <li>
                Stippl complies with applicable requirements under the EU AI Act (Regulation (EU) 2024/1689) in the
                design and deployment of AI Features. We do not use prohibited AI practices as defined by the Act.
              </li>
              <li>
                Where AI systems interact with you in a way that might not otherwise be apparent, we will make this
                clear within the Service.
              </li>
            </ul>

            <h2 id="feedback">10. Your Feedback to Us</h2>
            <p>
              You assign all rights, title, and interest in any Feedback You provide the Company. If for any reason such
              assignment is ineffective, You agree to grant the Company a non-exclusive, perpetual, irrevocable,
              royalty-free, worldwide right and license to use, reproduce, disclose, sublicense, distribute, modify, and
              exploit such Feedback without restriction.
            </p>

            <h2 id="service-availability">11. Service Availability</h2>
            <p>
              The Company endeavours to ensure the Service is accessible to users around the clock. However, access to
              the Service may be temporarily suspended without notice in the case of system failure, maintenance or
              repair, or for reasons beyond the Company's control. The Company does not guarantee that the Service, or
              any content provided through the Service, will always be available, uninterrupted, timely, secure, or free
              from errors.
            </p>
            <p>
              We reserve the right to change, modify, or remove the contents of the Service at any time or for any
              reason at our sole discretion without notice. Furthermore, we may have to suspend access to the Service,
              or close it indefinitely. Any new features or tools which are added to the current Service shall also be
              subject to these Terms and Conditions.
            </p>
            <p>
              We will not be liable if, for any reason, all or any part of the Service is unavailable at any time or for
              any period. From time to time, we may restrict access to some parts of the Service, or the entire Service,
              to users, including registered users.
            </p>

            <h2 id="force-majeure">12. Force Majeure</h2>
            <p>
              The Company shall not be considered in breach of its obligations hereunder to the extent that performance
              of such obligations is prevented or delayed by a Force Majeure Event. A "Force Majeure Event" refers to
              any event or circumstance that is beyond the reasonable control of the Company, including but not limited
              to acts of God (such as floods, earthquakes, hurricanes, and other natural disasters), war, terrorism,
              strikes or labour disputes, embargoes, government orders, pandemic, or any other force majeure event.
            </p>
            <p>
              Upon the occurrence of a Force Majeure Event, the Company will make reasonable efforts to notify users of
              the nature and extent of the circumstances causing the delay or failure to perform. Efforts will be made
              to resume performance as soon as possible following the event. However, during the duration of the Force
              Majeure Event, the obligations of the Company under these Terms and Conditions will be suspended, and we
              will not be liable for delays.
            </p>
            <p>
              This clause is intended to apply to the fullest extent permitted by applicable law and does not invalidate
              or render unenforceable the remaining provisions of these Terms and Conditions.
            </p>

            <h2 id="external-links">13. Links to Other Websites</h2>
            <p>
              Our Service may contain links to third-party web sites or services that are not owned or controlled by the
              Company. The Company has no control over, and assumes no responsibility for, the content, privacy
              policies, or practices of any third-party web sites or services. You further acknowledge and agree that
              the Company shall not be responsible or liable, directly or indirectly, for any damage or loss caused or
              alleged to be caused by or in connection with the use of or reliance on any such content, goods, or
              services available on or through any such web sites or services. We strongly advise You to read the terms
              and conditions and privacy policies of any third-party web sites or services that You visit.
            </p>

            <h2 id="termination">14. Termination</h2>
            <p>
              We may terminate or suspend Your Account immediately, without prior notice or liability, for any reason
              whatsoever, including without limitation if You breach these Terms and Conditions. Upon termination, Your
              right to use the Service will cease immediately. If You wish to terminate Your Account, You may simply
              discontinue using the Service or contact us at <a href="mailto:support@stippl.io">support@stippl.io</a>.
            </p>

            <h2 id="liability">15. Limitation of Liability</h2>
            <p>
              Notwithstanding any damages that You might incur, the entire liability of the Company and any of its
              suppliers under any provision of these Terms and Your exclusive remedy for all of the foregoing shall be
              limited to the amount actually paid by You through the Service or EUR 100 if You haven't purchased
              anything through the Service.
            </p>
            <p>
              To the maximum extent permitted by applicable law, in no event shall the Company or its suppliers be
              liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not
              limited to, damages for loss of profits, loss of data or other information, for business interruption, for
              personal injury, loss of privacy arising out of or in any way related to the use of or inability to use
              the Service, third-party software and/or third-party hardware used with the Service, or otherwise in
              connection with any provision of these Terms), even if the Company or any supplier has been advised of the
              possibility of such damages and even if the remedy fails of its essential purpose.
            </p>
            <p>
              Nothing in these Terms limits the Company's liability for death or personal injury caused by negligence,
              fraud, fraudulent misrepresentation, or any other liability that cannot be excluded under applicable
              mandatory law.
            </p>

            <h2 id="as-is">16. "AS IS" and "AS AVAILABLE" Disclaimer</h2>
            <p>
              The Service is provided to You "AS IS" and "AS AVAILABLE" and with all faults and defects without warranty
              of any kind. To the maximum extent permitted under applicable law, the Company, on its own behalf and on
              behalf of its Affiliates and its and their respective licensors and service providers, expressly disclaims
              all warranties, whether express, implied, statutory, or otherwise, with respect to the Service, including
              all implied warranties of merchantability, fitness for a particular purpose, title, and non-infringement,
              and warranties that may arise out of the course of dealing, course of performance, usage, or trade
              practice. Without limitation to the foregoing, the Company provides no warranty or undertaking, and makes
              no representation of any kind that the Service will meet Your requirements, achieve any intended results,
              be compatible or work with any other software, applications, systems, or services, operate without
              interruption, meet any performance or reliability standards or be error-free or that any errors or defects
              can or will be corrected.
            </p>

            <h2 id="dsa">17. EU Digital Services Act (DSA) Compliance</h2>
            <p>In accordance with Regulation (EU) 2022/2065 (the Digital Services Act), which has been fully applicable since February 2024:</p>
            <ul>
              <li>Stippl operates as an intermediary service provider within the meaning of the DSA.</li>
              <li>
                You may report content that you believe to be illegal or in violation of these Terms by contacting us at{" "}
                <a href="mailto:support@stippl.io">support@stippl.io</a> with the subject line "Content Report: DSA".
              </li>
              <li>We will process such reports in a timely manner and inform you of the outcome.</li>
            </ul>

            <h2 id="governing-law">18. Governing Law</h2>
            <p>
              The laws of the Netherlands, excluding its conflicts of law rules, shall govern these Terms and Your use
              of the Service. Your use of the Application may also be subject to other local, state, national, or
              international laws.
            </p>

            <h2 id="dispute-resolution">19. Dispute Resolution</h2>
            <p>
              If You have any concern or dispute about the Service, You agree to first try to resolve the dispute
              informally by contacting the Company at <a href="mailto:support@stippl.io">support@stippl.io</a>. If the dispute cannot be resolved informally, You
              and the Company agree to submit to the exclusive jurisdiction of the courts located in the Netherlands to
              resolve any legal matter arising from the Terms. However, the Company is still allowed to apply for
              injunctive remedies (or an equivalent type of urgent legal relief) in any jurisdiction.
            </p>
            <p>
              <strong>Help with a cross-border complaint:</strong> If You live in the EU and we cannot resolve a complaint
              together, the European Consumer Centre in your country can give you free advice. You can find yours on
              the{" "}
              <a href="https://www.eccnet.eu/" target="_blank" rel="noopener noreferrer">
                European Consumer Centres Network
              </a>{" "}
              website.
            </p>

            <h2 id="eu-users">20. For European Union (EU) Users</h2>
            <p>
              If You are a European Union consumer, you will benefit from any mandatory provisions of the law of the
              country in which you are resident. This means that, in addition to the protections offered by Dutch law,
              you may also avail yourself of any additional protections afforded to you by your home country's laws
              regarding the use of the Service.
            </p>

            <h2 id="severability-waiver">21. Severability and Waiver</h2>
            <h3 id="severability">21.1 Severability</h3>
            <p>
              If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and
              interpreted to accomplish the objectives of such provision to the greatest extent possible under
              applicable law, and the remaining provisions will continue in full force and effect.
            </p>
            <h3 id="waiver">21.2 Waiver</h3>
            <p>
              No waiver under these Terms shall be considered a further or continuing waiver of such term or any other
              term, and the Company's failure to assert any right or provision under these Terms shall not constitute a
              waiver of such right or provision.
            </p>

            <h2 id="changes">22. Changes to These Terms and Conditions</h2>
            <p>
              We reserve the right, at Our sole discretion, to modify or replace these Terms at any time. If a revision
              is material, we will make reasonable efforts to provide at least 30 days' notice prior to any new terms
              taking effect. By continuing to access or use Our Service after those revisions become effective, you
              agree to be bound by the revised terms. If you do not agree to the new terms, you are no longer authorized
              to use the Service.
            </p>

            <h2 id="contact">23. Contact Us</h2>
            <p>If you have any questions about these Terms and Conditions, please contact us:</p>
            <ul>
              <li>By email: <a href="mailto:support@stippl.io">support@stippl.io</a></li>
              <li>For eSIM support: <a href="mailto:support+esim@stippl.io">support+esim@stippl.io</a></li>
              <li>
                By visiting: our{" "}<a href="/contact">contact page</a>
              </li>
            </ul>

            <p>
              <em>© 2026 Stippl B.V. All rights reserved.</em>
            </p>
          </div>
        </div>
      </div>
      </div>
      <OutroCTA />
      <Footer />
    </div>
  );
};

export default Terms;
